import { Component, Panel } from "@mcleod/components";
import { CommonTooltips, KeyValuePair } from "@mcleod/common";

export class MaskTooltipHelper {
    private static keyValuePairs: KeyValuePair[] = [];

    static setTooltipData(validValues: any[]) {
        const result: KeyValuePair[] = [];
        validValues?.forEach(validValue => {
            result.push(new KeyValuePair(validValue.value, validValue.descr));
        });
        this.keyValuePairs = result;
    }

    private static getTooltipContent(): Panel {
        const header = "The mask used to automatically generate the master code.";
        return CommonTooltips.createKeyValueTooltipContent(this.keyValuePairs, header);
    }

    static setTooltipContent(component: Component) {
        if (component != null) {
            component.tooltipDynamicContent = () => this.getTooltipContent();
        }
    }
}
